"use client";
import * as React from "react";
import { Card, Text } from "@hubble/web";
import { Colors } from "themes/color-palette";
import { useTranslations } from "i18n";
import { Trans } from "i18n/Trans";
import { FILES } from "i18n/constants";
import { Link } from "i18n/routing";

const UkRiskSummary = () => {
  const t = useTranslations(FILES.PRICES);
  return (
    <Card customBgColor={Colors.blue[50]} mb={9} variant="filled">
      <Text.Heading marketing size="xxs" color={Colors.blue[500]} mb={1}>
        {t("riskSummaryTitle")}
        <Text.Body size="sm" marketing color={Colors.blue[500]}>
          {t("riskSummaryDescription")}
        </Text.Body>
      </Text.Heading>
      <Text.Heading marketing size="xxs" color={Colors.blue[500]} mb={1}>
        {t("riskSummaryTitle2")}
        <Text.Body size="sm" marketing color={Colors.blue[500]}>
          {t("riskSummaryDescription2")}
        </Text.Body>
      </Text.Heading>
      <Text.Heading marketing size="xxs" color={Colors.blue[500]} mb={1}>
        {t("riskSummaryTitle3")}
        <Text.Body size="sm" marketing color={Colors.blue[500]}>
          {t("riskSummaryDescription3")}
        </Text.Body>
      </Text.Heading>
      <Text.Heading marketing size="xxs" color={Colors.blue[500]} mb={1}>
        {t("riskSummaryTitle4")}
        <Text.Body size="sm" marketing color={Colors.blue[500]}>
          {t("riskSummaryDescription4")}
        </Text.Body>
      </Text.Heading>
      <Text.Heading marketing size="xxs" color={Colors.blue[500]} mb={1}>
        {t("riskSummaryTitle5")}
        <Text.Body size="sm" marketing color={Colors.blue[500]}>
          {t("riskSummaryDescription5")}
        </Text.Body>
      </Text.Heading>
      <Text.Heading marketing size="xxs" color={Colors.blue[500]} mb={1}>
        {t("riskSummaryTitle6")}
        <Text.Body size="sm" marketing color={Colors.blue[500]}>
          <Trans
            i18nKey={`${FILES.PRICES}.riskSummaryDescriptionLink`}
            components={[
              <Text.Link
                target="_blank"
                as={Link}
                href="/uk-fca-risks/product-risks"
                color={Colors.blue[500]}
              />
            ]}
          />
        </Text.Body>
      </Text.Heading>
    </Card>
  );
};

export default UkRiskSummary;
